import { Calendar, Twitter, Vote, Heart } from "lucide-react";
import { PROJECT_IMAGES } from "./index";

// Demo Data
export const DEMO = {
  user: {
    wallet_address: "addr1qx8mj2kf9n3lpz7v4...m4k9xy",
    username: "Player1",
    avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?seed=player1",
    level: 4,
    level_name: "Blaze",
    xp: 2847,
    next_level_xp: 4000,
    xp_progress: 71,
    diamonds: 44,
    burnz_tokens: 850,
    claimable_burnz: 284.7,
    uex_balance: 450,
    uex_vesting: 150,
    uexc_balance: 3420,
    energy: 180,
    max_energy: 200,
    notifications: 2,
    total_nfts_dumped: 34,
    total_quests_completed: 47,
    pools_joined: ["1", "3"],
    rank: 42,
    streak_days: 7,
    badges: [
      { name: "First Flame", icon: "🔥", description: "Registered first NFT" },
      { name: "Quest Master", icon: "⚔️", description: "Completed 10 quests" },
      { name: "Community Builder", icon: "👥", description: "Joined 5 pools" },
      { name: "Letting Go", icon: "💀", description: "First dump" },
    ],
  },
  featuredGame: {
    title: "Tribal Wars 2",
    description: "The sequel to the popular Tribal Wars kicks the gaming experience off with a minor settlement for players to develop.",
    image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800&h=400&fit=crop",
    players: "232.10k",
    badge: "BEST GAME",
  },
  fireBoard: [
    { name: "Smoke", burnz: "500K", color: "gray", icon: "💨" },
    { name: "Flame", burnz: "1M", color: "orange", icon: "🔥" },
    { name: "Volcano", burnz: "2.5M", color: "purple", icon: "🌋" },
  ],
  pools: [
    { id: "1", name: "Neon Apes Genesis", description: "Once the most hyped collection of 2024. Now seeking collective closure.", pool_type: "resolution", status: "active", member_count: 2847, nfts_registered: 8340, nfts_dumped: 2456, total_pool_xp: 45000, current_milestone: "bronze", next_milestone: "silver", milestone_progress: 90, uex_allocation: 100, uexc_allocation: 500, ai_strength_score: 78.5, participation_rate: 53.2, image: PROJECT_IMAGES["1"], trending: true, project_policy_id: "a3c4f2e1d5b6789012345678901234567890abcdef1234567890abcd" },
    { id: "2", name: "Cyber Punks CNF", description: "Abandoned project. Community united for resolution.", pool_type: "resolution", status: "voting", member_count: 4203, nfts_registered: 15670, nfts_dumped: 4230, total_pool_xp: 78000, current_milestone: "silver", next_milestone: "gold", milestone_progress: 78, uex_allocation: 500, uexc_allocation: 2500, ai_strength_score: 85.2, participation_rate: 45.4, image: PROJECT_IMAGES["2"], hot: true, project_policy_id: "b4d5e3f2a6c789012345678901234567890bcdef2345678901abcde" },
    { id: "3", name: "Meta Monkeys DAO", description: "Self-organizing community working towards ecosystem cleanup.", pool_type: "resolution", status: "active", member_count: 1856, nfts_registered: 5890, nfts_dumped: 1340, total_pool_xp: 23000, current_milestone: "bronze", next_milestone: "silver", milestone_progress: 46, uex_allocation: 100, uexc_allocation: 500, ai_strength_score: 72.8, participation_rate: 39.6, image: PROJECT_IMAGES["4"], new: true },
    { id: "4", name: "Pixel Warriors", description: "Former gaming NFT project community banding together.", pool_type: "resolution", status: "active", member_count: 1234, nfts_registered: 3450, nfts_dumped: 890, total_pool_xp: 15600, current_milestone: "bronze", next_milestone: "silver", milestone_progress: 31, uex_allocation: 100, uexc_allocation: 500, ai_strength_score: 68.4, participation_rate: 41.2, image: PROJECT_IMAGES["5"] },
  ],
  // Partners are B2B clients who pay for marketing quests
  partners: [
    { id: "p1", name: "DeFi Protocol X", description: "Leading DeFi protocol seeking community marketing", logo: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=100&h=100&fit=crop", status: "active", active_quests: 3, total_spent: 5000, completions: 12450, website: "https://example.com", twitter: "@defixprotocol", verified: true },
    { id: "p2", name: "NFT Marketplace Y", description: "New NFT marketplace launching community campaigns", logo: "https://images.unsplash.com/photo-1642104704074-907c0698cbd9?w=100&h=100&fit=crop", status: "active", active_quests: 5, total_spent: 8500, completions: 23400, website: "https://example.com", twitter: "@nftmarketplacey", verified: true },
    { id: "p3", name: "GameFi Studio Z", description: "Web3 gaming studio promoting new releases", logo: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=100&h=100&fit=crop", status: "active", active_quests: 2, total_spent: 3200, completions: 8900, website: "https://example.com", twitter: "@gamefistudioz", verified: false },
  ],
  // ========== QUESTS (Web2-Friendly Marketing Campaigns) ==========
  // Quest Types: share, visit, follow, review, referral
  // Rewards: XP only (no BURNZ for quests)
  quests: [
    // Onboarding Quest (Redesigned for simplicity)
    { 
      id: "q0", 
      partner_id: null, 
      title: "Welcome to Burnz Union", 
      description: "Get started and earn your first rewards. Takes less than 5 minutes.", 
      quest_type: "follow", 
      xp_reward: 450, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 45962, 
      time_estimate: "5 min", 
      featured: true, 
      is_onboarding: true, 
      partner_name: "Burnz Union", 
      tasks: [
        { id: "t0-0", title: "Sign up UEX account", description: "Create your UEX.us account for trading rewards", xp_reward: 100, is_completed: false, action_url: "https://uex.us/?ref=5jcsh81dhaos", action_label: "Sign Up", verification_type: "self" },
        { id: "t0-1", title: "Create Your Account", description: "Connect your wallet or sign up", xp_reward: 50, is_completed: false, action_label: "Connect", verification_type: "self" },
        { id: "t0-2", title: "Join Our Community", description: "Join the Burnz Union Discord", xp_reward: 100, is_completed: false, action_url: "https://discord.gg/74wEdNQ5tC", action_label: "Join Discord", verification_type: "self" },
        { id: "t0-3", title: "Follow on Twitter", description: "Stay updated with announcements", xp_reward: 100, is_completed: false, action_url: "https://twitter.com/BurnzUnion", action_label: "Follow", verification_type: "self" },
        { id: "t0-4", title: "Join a Team", description: "Pick a recovery team to support", xp_reward: 100, is_completed: false, action_url: "/app/teams", action_label: "Browse Teams", verification_type: "self" },
      ]
    },
    // Share & Amplify Quest
    { 
      id: "q1", 
      partner_id: null, 
      title: "Share Our Launch Announcement", 
      description: "Help spread the word about our new features by sharing on social media.", 
      quest_type: "share", 
      xp_reward: 200, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 2847, 
      time_estimate: "2 min", 
      partner_name: "Burnz Union",
      featured: true,
      tasks: [
        { id: "t1-1", title: "Share on Twitter/X", description: "Share the announcement with your followers", xp_reward: 100, is_completed: false, action_url: "https://twitter.com/intent/tweet?text=Check%20out%20@BurnzUnion", action_label: "Share", verification_type: "link" },
        { id: "t1-2", title: "Tag a Friend", description: "Mention someone who should know about this", xp_reward: 100, is_completed: false, action_label: "Done", verification_type: "self" },
      ]
    },
    // Visit & Engage Quest (Web2 Favorite)
    { 
      id: "q2", 
      partner_id: "p1", 
      title: "Explore DeFi Protocol X", 
      description: "Visit our partner site and explore their new lending features.", 
      quest_type: "visit", 
      xp_reward: 150, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 1523, 
      time_estimate: "3 min", 
      partner_name: "DeFi Protocol X",
      tasks: [
        { id: "t2-1", title: "Visit Landing Page", description: "Check out the new features page", xp_reward: 50, is_completed: false, action_url: "https://example.com/features", action_label: "Visit", verification_type: "tracking" },
        { id: "t2-2", title: "Read How It Works", description: "Scroll through the explanation section", xp_reward: 50, is_completed: false, action_label: "Done", verification_type: "self" },
        { id: "t2-3", title: "Click Get Started", description: "Explore the signup flow", xp_reward: 50, is_completed: false, action_label: "Done", verification_type: "self" },
      ]
    },
    // Follow / Subscribe Quest
    { 
      id: "q3", 
      partner_id: "p2", 
      title: "Follow NFT Marketplace Y", 
      description: "Support our partner by following their social channels.", 
      quest_type: "follow", 
      xp_reward: 200, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 3421, 
      time_estimate: "2 min", 
      partner_name: "NFT Marketplace Y",
      tasks: [
        { id: "t3-1", title: "Follow on Twitter", description: "Follow @NFTMarketplaceY", xp_reward: 100, is_completed: false, action_url: "https://twitter.com/NFTMarketplaceY", action_label: "Follow", verification_type: "self" },
        { id: "t3-2", title: "Subscribe to Newsletter", description: "Get weekly updates", xp_reward: 100, is_completed: false, action_url: "https://example.com/newsletter", action_label: "Subscribe", verification_type: "self" },
      ]
    },
    // Review & Feedback Quest (High Value for Web2)
    { 
      id: "q4", 
      partner_id: "p3", 
      title: "Review GameFi Studio Z", 
      description: "Share your honest feedback about their new game.", 
      quest_type: "review", 
      xp_reward: 300, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 456, 
      time_estimate: "5 min", 
      partner_name: "GameFi Studio Z",
      tasks: [
        { id: "t4-1", title: "Play the Demo", description: "Try the game for at least 10 minutes", xp_reward: 100, is_completed: false, action_url: "https://example.com/game", action_label: "Play", verification_type: "self" },
        { id: "t4-2", title: "Submit Feedback", description: "Answer 3 quick questions about your experience", xp_reward: 100, is_completed: false, action_url: "https://example.com/feedback", action_label: "Give Feedback", verification_type: "link" },
        { id: "t4-3", title: "Rate on App Store", description: "Leave an honest rating (optional)", xp_reward: 100, is_completed: false, action_label: "Rate", verification_type: "self" },
      ]
    },
    // Referral Quest
    { 
      id: "q5", 
      partner_id: null, 
      title: "Invite Friends to Burnz Union", 
      description: "Grow our community by inviting friends who want a fresh start.", 
      quest_type: "referral", 
      xp_reward: 500, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 892, 
      time_estimate: "5 min", 
      partner_name: "Burnz Union",
      tasks: [
        { id: "t5-1", title: "Copy Your Referral Link", description: "Get your unique invite link", xp_reward: 50, is_completed: false, action_url: "/app/profile?tab=referral", action_label: "Get Link", verification_type: "self" },
        { id: "t5-2", title: "Share with 3 Friends", description: "Send to friends who might be interested", xp_reward: 150, is_completed: false, action_label: "Shared", verification_type: "self" },
        { id: "t5-3", title: "Friend Joins", description: "Earn bonus when a friend signs up", xp_reward: 300, is_completed: false, action_label: "Waiting...", verification_type: "api" },
      ]
    },
    // ========== NEW QUESTS WITH TWITTER/DISCORD VERIFICATION ==========
    // Twitter Engagement Quest
    { 
      id: "q6", 
      partner_id: null, 
      title: "Twitter Engagement Challenge", 
      description: "Engage with Burnz Union on Twitter to earn XP. All tasks are verified!", 
      quest_type: "follow", 
      xp_reward: 400, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 1245, 
      time_estimate: "5 min", 
      partner_name: "Burnz Union",
      featured: true,
      verification_required: true,
      tasks: [
        { id: "t6-1", title: "Follow @BurnzUnion", description: "Follow our official Twitter account", xp_reward: 100, is_completed: false, action_url: "https://twitter.com/BurnzUnion", action_label: "Follow", verification_type: "twitter_follow", twitter_handle: "BurnzUnion" },
        { id: "t6-2", title: "Retweet Pinned Post", description: "Retweet our pinned announcement", xp_reward: 100, is_completed: false, action_url: "https://twitter.com/BurnzUnion", action_label: "Retweet", verification_type: "twitter_retweet" },
        { id: "t6-3", title: "Quote Tweet About Us", description: "Share your thoughts about Burnz Union", xp_reward: 150, is_completed: false, action_url: "https://twitter.com/intent/tweet?text=Just%20joined%20@BurnzUnion%20-%20the%20community%20for%20rugged%20NFT%20holders%20to%20rebuild%20together!%20🔥", action_label: "Quote Tweet", verification_type: "twitter_quote" },
        { id: "t6-4", title: "Tag 2 Friends", description: "Tag friends who should know about us", xp_reward: 50, is_completed: false, action_label: "Done", verification_type: "manual" },
      ]
    },
    // Discord Community Quest
    { 
      id: "q7", 
      partner_id: null, 
      title: "Join Our Discord Community", 
      description: "Become an active member of the Burnz Union Discord server.", 
      quest_type: "follow", 
      xp_reward: 350, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 2341, 
      time_estimate: "5 min", 
      partner_name: "Burnz Union",
      featured: true,
      verification_required: true,
      tasks: [
        { id: "t7-1", title: "Join Discord Server", description: "Join the official Burnz Union Discord", xp_reward: 100, is_completed: false, action_url: "https://discord.gg/74wEdNQ5tC", action_label: "Join", verification_type: "discord_join", discord_server: "74wEdNQ5tC" },
        { id: "t7-2", title: "Verify in #verify", description: "Complete verification in the verify channel", xp_reward: 50, is_completed: false, action_label: "Verify", verification_type: "discord_role" },
        { id: "t7-3", title: "Introduce Yourself", description: "Say hello in #introductions channel", xp_reward: 100, is_completed: false, action_label: "Introduce", verification_type: "discord_message" },
        { id: "t7-4", title: "React to Announcements", description: "React to 3 posts in #announcements", xp_reward: 100, is_completed: false, action_label: "React", verification_type: "manual" },
      ]
    },
    // Social Media Blitz Quest
    { 
      id: "q8", 
      partner_id: null, 
      title: "Social Media Blitz", 
      description: "Complete tasks across multiple social platforms for bonus XP!", 
      quest_type: "share", 
      xp_reward: 600, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 678, 
      time_estimate: "10 min", 
      partner_name: "Burnz Union",
      featured: true,
      tasks: [
        { id: "t8-1", title: "Follow on Twitter", description: "Follow @BurnzUnion on Twitter/X", xp_reward: 100, is_completed: false, action_url: "https://twitter.com/BurnzUnion", action_label: "Follow", verification_type: "twitter_follow", twitter_handle: "BurnzUnion" },
        { id: "t8-2", title: "Join Discord", description: "Join our Discord community", xp_reward: 100, is_completed: false, action_url: "https://discord.gg/74wEdNQ5tC", action_label: "Join", verification_type: "discord_join" },
        { id: "t8-3", title: "Like & RT Launch Tweet", description: "Like and retweet our launch announcement", xp_reward: 150, is_completed: false, action_url: "https://twitter.com/BurnzUnion", action_label: "Like & RT", verification_type: "twitter_engagement" },
        { id: "t8-4", title: "Share in Discord", description: "Share your wallet address in #verify", xp_reward: 100, is_completed: false, action_label: "Share", verification_type: "discord_message" },
        { id: "t8-5", title: "Post Screenshot Proof", description: "Post proof of completion in #quests", xp_reward: 150, is_completed: false, action_label: "Post", verification_type: "screenshot" },
      ]
    },
    // Content Creator Quest
    { 
      id: "q9", 
      partner_id: null, 
      title: "Content Creator Challenge", 
      description: "Create original content about Burnz Union and earn big XP!", 
      quest_type: "share", 
      xp_reward: 1000, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 156, 
      time_estimate: "20 min", 
      partner_name: "Burnz Union",
      featured: false,
      premium: true,
      tasks: [
        { id: "t9-1", title: "Create a Thread", description: "Write a Twitter thread about rugged NFTs and recovery", xp_reward: 300, is_completed: false, action_url: "https://twitter.com/intent/tweet", action_label: "Create Thread", verification_type: "twitter_thread" },
        { id: "t9-2", title: "Make a Video", description: "Create a short video (TikTok/YouTube Shorts) about Burnz Union", xp_reward: 400, is_completed: false, action_label: "Submit Link", verification_type: "link_submission" },
        { id: "t9-3", title: "Write an Article", description: "Write a Medium or blog post about Web3 community recovery", xp_reward: 300, is_completed: false, action_label: "Submit Article", verification_type: "link_submission" },
      ]
    },
    // Weekly Twitter Space Quest
    { 
      id: "q10", 
      partner_id: null, 
      title: "Weekly Twitter Space", 
      description: "Join our weekly Twitter Space and participate in the discussion.", 
      quest_type: "follow", 
      xp_reward: 250, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 432, 
      time_estimate: "30 min", 
      partner_name: "Burnz Union",
      recurring: true,
      tasks: [
        { id: "t10-1", title: "Set Reminder", description: "Turn on notifications for @BurnzUnion Spaces", xp_reward: 50, is_completed: false, action_url: "https://twitter.com/BurnzUnion", action_label: "Enable Notifications", verification_type: "self" },
        { id: "t10-2", title: "Join the Space", description: "Join our weekly Twitter Space (Thursdays 6PM UTC)", xp_reward: 100, is_completed: false, action_label: "Join", verification_type: "twitter_space" },
        { id: "t10-3", title: "Ask a Question", description: "Request to speak and ask a question", xp_reward: 100, is_completed: false, action_label: "Requested", verification_type: "manual" },
      ]
    },
    // Cardano Ecosystem Quest
    { 
      id: "q11", 
      partner_id: null, 
      title: "Explore Cardano Ecosystem", 
      description: "Learn about the Cardano ecosystem and support fellow projects.", 
      quest_type: "visit", 
      xp_reward: 300, 
      burnz_reward: 0, 
      status: "active", 
      completions_count: 891, 
      time_estimate: "10 min", 
      partner_name: "Burnz Union",
      tasks: [
        { id: "t11-1", title: "Visit Cardano Foundation", description: "Explore cardano.org and learn about the ecosystem", xp_reward: 75, is_completed: false, action_url: "https://cardano.org", action_label: "Visit", verification_type: "self" },
        { id: "t11-2", title: "Follow 3 Cardano Projects", description: "Follow 3 other Cardano projects on Twitter", xp_reward: 75, is_completed: false, action_label: "Done", verification_type: "self" },
        { id: "t11-3", title: "Join Cardano Discord", description: "Join the main Cardano community Discord", xp_reward: 75, is_completed: false, action_url: "https://discord.gg/cardano", action_label: "Join", verification_type: "discord_join" },
        { id: "t11-4", title: "Share Cardano Content", description: "Retweet or share helpful Cardano content", xp_reward: 75, is_completed: false, action_label: "Shared", verification_type: "self" },
      ]
    },
  ],
  // Removed complex daily quests - replaced with simple XP tracking
  dailyQuests: [
    { id: "dq1", title: "Daily Check-in", description: "Visit the platform daily", xp_reward: 25, burnz_reward: 0, completed: true, icon: Calendar, streak: 7 },
    { id: "dq2", title: "Complete a Quest", description: "Finish any active quest", xp_reward: 50, burnz_reward: 0, completed: false, icon: Twitter },
  ],
  stories: [
    { id: "s1", title: "The Fall of Neon Apes", subtitle: "A story of hope, silence, and letting go", pool_id: "1", reads: 12500, likes: 3400, image: PROJECT_IMAGES["1"], content: [
      { act: "The Mint", narration: "They said this was the future. And for a moment... we believed them.", description: "Bright colors. Discord buzzing. Roadmap glowing." },
      { act: "The Silence", narration: "No announcement ever said it was over. It just... stopped.", description: "Empty Discord. Unread messages. Clocks without hands." },
      { act: "The Rug", narration: "The rug wasn't pulled. We were left standing on nothing.", description: "Worthless tokens. Charts fading to dust." },
      { act: "The Dump", narration: "Dumping was never about hate. It was about letting go.", description: "NFTs finding new purpose. Names recorded." },
      { act: "Forward", narration: "We didn't rebuild. We built a place to move forward.", description: "People gather. Stories recorded." },
    ]},
    { id: "s2", title: "Cyber Dreams Shattered", subtitle: "When the metaverse promised everything", pool_id: "2", reads: 8900, likes: 2100, image: PROJECT_IMAGES["2"] },
  ],
  stats: { total_pools: 24, total_users: 45962, total_nfts_dumped: 78366, total_burnz_burned: 156000, total_quest_completions: 234560, partner_projects: 12 },
  leaderboard: [
    { rank: 1, name: "CryptoKing", avatar: "🦁", level: "Phoenix", xp: 15340, change: 0 },
    { rank: 2, name: "DumpMaster", avatar: "🔥", level: "Phoenix", xp: 14890, change: 1 },
    { rank: 3, name: "NFTHunter", avatar: "🎯", level: "Inferno", xp: 12234, change: -1 },
    { rank: 4, name: "DiamondHands", avatar: "💎", level: "Inferno", xp: 9870, change: 2 },
    { rank: 5, name: "MoonWalker", avatar: "🌙", level: "Blaze", xp: 7654, change: 0 },
  ],
  milestones: [
    { name: "Bronze", xp_threshold: 10000, uex_reward: 100, uexc_reward: 500, icon: "🥉" },
    { name: "Silver", xp_threshold: 50000, uex_reward: 500, uexc_reward: 2500, icon: "🥈" },
    { name: "Gold", xp_threshold: 100000, uex_reward: 1000, uexc_reward: 5000, icon: "🥇" },
    { name: "Diamond", xp_threshold: 500000, uex_reward: 5000, uexc_reward: 25000, icon: "💎" },
    { name: "Legendary", xp_threshold: 1000000, uex_reward: 10000, uexc_reward: 50000, icon: "👑" },
  ],
  partnerPricing: {
    selfServe: { ada: 50, burnz: 500, features: ["Create unlimited quests", "Basic analytics", "Self-verification", "Community support"] },
    managed: { ada: 200, features: ["Campaign creation by BURNZ team", "Advanced analytics", "Priority verification", "Featured placement", "Dedicated support"] },
    // Three-tier custom pricing for large campaigns
    customTiers: {
      starter: { 
        name: "Starter Campaign", 
        ada: 500, 
        burnz: 5000, 
        reach: "10K-25K", 
        duration: "2 weeks",
        features: ["Up to 3 quest types", "10K-25K user reach", "Basic targeting", "Standard analytics", "Email support"]
      },
      growth: { 
        name: "Growth Campaign", 
        ada: 1500, 
        burnz: 15000, 
        reach: "50K-100K", 
        duration: "4 weeks",
        features: ["Up to 7 quest types", "50K-100K user reach", "Advanced targeting", "Real-time analytics", "Priority support", "Featured placement", "Social amplification"]
      },
      enterprise: { 
        name: "Enterprise Campaign", 
        ada: 5000, 
        burnz: 50000, 
        reach: "250K+", 
        duration: "8 weeks",
        features: ["Unlimited quest types", "250K+ user reach", "Custom targeting", "Dedicated dashboard", "24/7 support", "Homepage takeover", "Influencer partnerships", "Custom integrations", "White-glove service"]
      }
    }
  },
};
